module.exports = __webpack_public_path__ + "img/Tutorial_CategoricalDeskriptor.4c16f1a5.jpg";